<template>
  <div class="CustomerServices" v-if="CompanyID">
    <div @touchstart="Touchstart($event)" @touchmove="Touchmove($event)" @touchend="Touchend($event)"
      id="CustomerServices" class="CustomerServices-wrapper">
      <ul class="CustomerServices-item slidein-spring " :class="{'showFade':ShowFadeFlag,'fadeBottom':isBottom }">
        <li class="CustomerServices-wrap">
          <span  @click="ShowFade($event)">
            <img  src="/static/img/mascot.png"
               />
          </span>
          <!-- <span @click="ShowFade($event)">
            <img class="resting" src="/static/img/mascot.png"
              style="width:0.25rem;height:0.25rem;position: absolute;left: 50%;margin-left: -0.125rem;top: 50%;margin-top: -0.125rem;" />
            <img class="active" src="/static/img/delete_icon.png"
              style="width:0.25rem;height:0.25rem;;position: absolute;left: 50%;margin-left: -0.125rem;top: 50%;margin-top: -0.125rem;" />
          </span> -->
          <ul class="CustomerServices-list">
            <!-- <li @click="customerServices">
              <img src="/static/img/kefu1.png" style="width:0.45rem;height:0.45rem;vertical-align: middle" />
            </li> -->
            <li style="background:#1CD49E">
              <img @click="messageNotify" src="/static/img/xiaoxi1.png"  />
            </li>
            <li style="background:#FEAE00">
              <img @click="ToFeedBack" src="/static/img/feedBack-icon1.png"  />
            </li>
            <li style="background:#B35CFF">
              <img @click="showUdesk" id="btn_udesk_im" src="/static/img/kefu4.png" />
            </li>
            <!-- <li>
              <a target="_blank" href="https://mp.weixin.qq.com/s/KAtYo1qeGOfCEIh62kq6mA">
                <img src="/static/img/xiaoxi.png" style="width:0.45rem;height:0.45rem;vertical-align: middle" />
              </a>
            </li> -->
          </ul>
        </li>
      </ul>
    </div>
    <transition name="picker-fade">
      <div class="picker" v-show="stateServices===1" @touchmove.prevent @click="cancel">
        <transition name="picker-move">
          <div class="picker-panel" v-if="stateServices===1" @click.stop>
            <div class="picker-choose border-bottom-1px">
              <label @click="cancel">
                <img style="width:0.14rem" src="/static/img/close.png" />
              </label>
              <div class="picker-title">
                <div>
                  <span>{{$t('system.CustomerService')}}&{{$t('system.Sell')}}</span>
                </div>
                <div>
                  <img style="width:0.13rem;vertical-align: text-top" src="/static/img/call.png" />
                  <span style="vertical-align:text-top">{{$t('system.ContactUs')}}</span>
                </div>
              </div>
            </div>
            <div class="picker-content" style="padding:0 0.1rem;">
              <div class="picker-item" v-if="Service.ContactMobile!=''" v-for="Service in Services">
                <div>
                  <span class="Service-UserName ellipsis">{{Service.UserName}}</span>
                  <span class="Service-Type" style="vertical-align: middle;"
                    :style="{'background-color':Service.DepartmentName==$t('system.ServiceDept')?'#d1edff':'#ffe0cc','color':Service.DepartmentName==$t('system.ServiceDept')?'#17a5ff':'#ff6600'}">{{Service.DepartmentName}}</span>
                </div>
                <div>
                  <a :href="`tel:${Service.ContactMobile}`">
                    <img style="width:0.13rem;vertical-align:middle" src="/static/img/callb.png">
                    <span style="color:#666;vertical-align:middle">{{$t('system.Call')}}</span></a>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
    <!-- <div @touchstart="Touchstart($event)" @touchmove="Touchmove($event)" @touchend="Touchend($event)" id="CustomerServices"
      class="CustomerServices-wrapper">
      <img src="/static/img/kefu.png" />
    </div>
    -->
    <transition name="explain-fade">
      <div style="background: rgba(255, 255, 255, .85);" class="explain" v-show="state===1" @click="hide"
        @touchmove.prevent></div>
    </transition>
  </div>
</template>

<style scoped>
  .showFade .active,
  .showFade .resting {
    transform: scale(1) rotate(0deg);
  }


  .active,
  .resting {
    transform: scale(1) rotate(-360deg);
    transition: transform 150ms cubic-bezier(0.4, 0, 1, 1);
  }

  .active {
    opacity: 0;
  }

  .showFade .resting {
    opacity: 0;
    position: absolute !important;
  }

  .showFade .active {
    opacity: 1;
  }


  .explain {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 98;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(0, 0, 0, .2);
    color: #fff;
  }


  .explain-fade-enter,
  .explain-fade-leave-active {
    opacity: 0
  }

  .explain-fade-enter-active,
  .explain-fade-leave-active {
    transition: all .3s ease-in-out;
  }

  a {
    text-decoration: none;
  }

  .picker {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(37, 38, 45, .4);

  }

  .picker-fade-enter,
  .picker-fade-leave-active {
    opacity: 0
  }

  .picker-fade-enter-active,
  .picker-fade-leave-active {
    transition: all .5s ease-in-out;
  }


  .picker-panel {
    position: absolute;
    z-index: 600;
    bottom: 0;
    width: 100%;
    background: #fff;
    border-top-left-radius: 0.05rem;
    border-top-right-radius: 0.05rem;
  }

  .picker-move-enter,
  .picker-move-leave-active {
    transform: translate3d(0, 2.73rem, 0)
  }

  .picker-move-enter-active,
  .picker-move-leave-active {
    transition: all .3s ease-in-out
  }

  .picker-choose {
    position: relative;
    height: 0.85rem;
    background-image: url('/static/img/kefubg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-top-left-radius: 0.05rem;
    border-top-right-radius: 0.05rem;
  }

  .picker-choose>label {
    position: absolute;
    right: 0;
    top: 0;
    padding: 0.1rem 0.15rem;
  }

  .picker-title {
    position: absolute;
    top: 0.2rem;
    left: 1.3rem;
    font-size: 0.13rem;
    color: #fff;
  }

  .picker-title>div:first-child {
    font-size: 0.18rem;
  }

  .picker-title>div:last-child {
    padding-top: 0.05rem;
  }

  .picker-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.15rem 0;
    border-bottom: 0.01rem solid #e3e3e3;
    box-sizing: border-box;
    color: #363f4b;
    font-size: 0.14rem;
  }

  .confirm,
  .cancel {
    position: absolute;
    top: 0;
    padding: 0.1rem;
    font-size: 0.14rem
  }

  .confirm {
    right: 0;
  }

  .cancel {
    left: 0
  }

  .option-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .option-title div {
    flex: 3;
    text-align: center;
    font-size: 0.12rem;
  }

  .CustomerServices-wrapper {
    position: fixed;
    right: 0.25rem;
    bottom: 1.16rem;
    z-index: 99;
    width: 0.55rem;
    height: 0.4rem;
  
  }

  .CustomerServices-wrapper img {
    width: 100%;
    height: 100%;
  }

  .Service-UserName {
    display: inline-block;
    width: 0.6rem;
    vertical-align: middle;
  }

  .Service-Type {
    font-size: 0.12rem;
    padding: 0.03rem 0.1rem;
    border-radius: 0.2rem;
  }


  .CustomerServices-item {
    /* box-sizing: border-box;
    margin: 25px;
    position: fixed;
    white-space: nowrap;
    z-index: 30;
    padding-left: 0; */
    list-style: none;
  }

  .CustomerServices-item *,
  .CustomerServices-item *:before,
  .CustomerServices-item *:after {
    box-sizing: inherit;
  }

  .CustomerServices-item {
    right: 0;
    bottom: 0;
  }

  .CustomerServices-list {
    list-style: none;
    margin: 0;
    padding: 0;
  
  }

  .CustomerServices-list>li {
    display: block;
    position: absolute;
    top: 0;
    /* padding: 0.05rem 0; */
    margin: -0.1rem 0;
    width: 0.45rem;
    height: 0.45rem;
    /* text-align: center; */
    border-radius: 50%;
    box-sizing: border-box
  }


  .CustomerServices-wrap>span {
    width: 0.55rem;
    display: inline-block;
    position: absolute;
    z-index: 2;
    font-size: 0;
    /* line-height: 0.45rem; */
    /* text-align: center; */
    /* background-color: #fff;
   ;
    border-radius: 50%;
    box-shadow: 0 0 0.07rem #d7d7d7; */
  }


  .CustomerServices-item.slidein .CustomerServices-list li {
    opacity: 0;
    transition: all 0.5s;
  }
  .CustomerServices-list li img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%) ;
    width:60%;
    height:60%;
    /* vertical-align: middle; */
    /* margin:0 auto; */
  }
  .CustomerServices-item.slidein.showFade .CustomerServices-list li {
    opacity: 1;
  }

  .CustomerServices-item.slidein.showFade .CustomerServices-list li:nth-child(1) {
    transform: translateY(-0.55rem);
  }

  .CustomerServices-item.slidein.showFade .CustomerServices-list li:nth-child(2) {
    transform: translateY(-1.1rem);
  }

  .CustomerServices-item.slidein.showFade .CustomerServices-list li:nth-child(3) {
    transform: translateY(-1.65rem);
  }

  .CustomerServices-item.slidein-spring .CustomerServices-list li {
    opacity: 0;
    transition: all 0.5s;
    transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .CustomerServices-item.slidein-spring .CustomerServices-list li:nth-child(1) {
    transition-delay: 0.05s;
  }

  .CustomerServices-item.slidein-spring .CustomerServices-list li:nth-child(2) {
    transition-delay: 0.1s;
  }

  .CustomerServices-item.slidein-spring .CustomerServices-list li:nth-child(3) {
    transition-delay: 0.15s;
  }

  .CustomerServices-item.slidein-spring.showFade .CustomerServices-list li {
    opacity: 1;
  }

  .CustomerServices-item.slidein-spring.showFade .CustomerServices-list li:nth-child(1) {
    transition-delay: 0.05s;
    transform: translateY(-0.55rem);
  }

  .CustomerServices-item.slidein-spring.showFade .CustomerServices-list li:nth-child(2) {
    transition-delay: 0.1s;
    transform: translateY(-1.1rem);
  }

  .CustomerServices-item.slidein-spring.showFade .CustomerServices-list li:nth-child(3) {
    transition-delay: 0.15s;
    transform: translateY(-1.65rem);
  }

  .CustomerServices-item.slidein-spring.showFade.fadeBottom .CustomerServices-list li:nth-child(1) {
    transition-delay: 0.05s;
    transform: translateY(0.55rem);
  }

  .CustomerServices-item.slidein-spring.showFade.fadeBottom .CustomerServices-list li:nth-child(2) {
    transition-delay: 0.1s;
    transform: translateY(1.1rem);
  }

  .CustomerServices-item.slidein-spring.showFade.fadeBottom .CustomerServices-list li:nth-child(3) {
    transition-delay: 0.15s;
    transform: translateY(1.65rem);
  }
</style>
<script>
  import explain from './explain.vue'
  import Scroll from './Scroll.vue'
  import BScroll from 'better-scroll'
  const STATE_HIDE = 0
  const STATE_SHOW = 1
  const COMPONENT_NAME = 'picker'
  const EVENT_VALUE_CHANGE = 'valuechange'
  const EVENT_CANCEL = 'cancel'
  const EVENT_CHANGE = 'change'
  import popOut from './pop-out.vue'
  export default {
    data() {
      return {
        state: STATE_HIDE,
        stateServices: STATE_HIDE,
        Flag: 0,
        disX: 0,
        moveX: 0,
        starX: 0,
        starY: 0,
        cancelTxt: '',
        confirmTxt: '',
        Services: [],
        ShowFadeFlag: false,
        isBottom: false,
        product: {},
        ContactList: {}
      }
    },
    computed: {
      CompanyID() {
        return this.$store.getters.ticketInfo.CompanyID;
      },
      UserID() {
        return this.$store.getters.ticketInfo.UserID;
      },
      UserName() {
        return this.$store.getters.ticketInfo.UserName;
      },
      CompanyName() {
        return this.$store.getters.ticketInfo.CompanyName;
      },
      RoleTypes() {
        return this.$store.getters.categorys.types.RoleType;
      },
      UserAct() {
        return this.$store.getters.ticketInfo.UserAct;
      },
      ContactMobile() {
        return this.$store.getters.ticketInfo.ContactMobile;
      }
    },

    watch: {
      'UserID'() {
        let __self = this;
        if (__self.UserID) {
          __self.__init();
          __self.getContactList();
        }
      }
    },
    methods: {
      getContactList() {
        let __self = this;
        let data = {
          RoleID: __self.UserID
        }
        __self.$api.system.getContactList(data).then(function (json) {
          if (json.data.isSucc) {
            let result = _.find(json.data.result.entities, o => {
              return o.IsDefault == 1150;
            })
            if (result) {
              __self.ContactList = result;
            }
          }
        });
      },
      udInit(Titles, ErrorMessage, Tags) {
        let __self = this;
        (function (a, h, c, b, f, g) { a["UdeskApiObject"] = f; a[f] = a[f] || function () { (a[f].d = a[f].d || []).push(arguments) }; g = h.createElement(c); g.async = 1; g.charset = "utf-8"; g.src = b; c = h.getElementsByTagName(c)[0]; c.parentNode.insertBefore(g, c) })(window, document, "script", "https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js", "ud");
        let timestamp = new Date().getTime();
        function getNonceStr() {
          return Math.random().toString(36).substr(2, 15);
        }
        let nonce = getNonceStr();
        var sign_str = `nonce=${nonce}&timestamp=${timestamp}&web_token=${__self.UserID}&22d39dbf4792d4e66ea5d0b0308b5983`;
        sign_str = sha1(sign_str);
        sign_str = sign_str.toUpperCase();
        ud({
          "code": "5b464e8",
          "link": "https://lichengtrip.s2.udesk.cn/im_client/?web_plugin_id=4981",
          "mode": "inner",
          "color": "#307AE8",
          "pos_flag": "srb",
          "language": "zh-cn", //语言-中文
          "session_key": "afeoqe",
          "onlineText": "联系客服，在线咨询",
          "offlineText": "客服下班，请留言",
          "targetSelector": "#btn_udesk_im",
          "selector": "#btn_udesk_im",
        });
        ud({
          "mobile": {
            "mode": "inner",
            "color": "#307AE8",
            "pos_flag": "crb",
            "onlineText": "联系客服，在线咨询",
            "offlineText": "客服下班，请留言"
          }
        })
        ud({
          "customer": {
            "nonce": nonce,
            "signature": sign_str,
            "timestamp": timestamp,
            "c_name": __self.UserName,
            "web_token": __self.UserID,
            "customer_token": __self.UserID,
            "c_org": __self.CompanyName,
            "c_tags": Tags,
            "c_phone": __self.ContactList.ContactPhone,
            "c_email": __self.ContactList.ContactEmail,
            "c_cf_页面信息": Titles,
            "c_cf_近期报错": ErrorMessage,

          }
        })
        ud({
          "panel": {
            "css": {
              "top": "0",
              "left": "0"
            },
            "onToggle": function (data) {  //面板开关时间
              if (data.visible) {
                console.log('窗口打开');
              }
              else {
                console.log('窗口关闭');
                __self.hide();
              }
            }
          }
        });
        // ud({
        //   "product": {
        //     "title": "",
        //     "产品描述": "Apple iPhone 7"
        //   }
        // })
      },
      showUdesk() {
        let __self = this;
        if (__self.CompanyID && window.lch_udesk && window.lch_udesk.show) {
          if ($utils.ErrorMessage.length > 0) {
            __self.product['错误信息'] = JSON.stringify($utils.ErrorMessage)
          }
          let Titles = '无页面信息';
          if ($utils.getTitle()) {
            Titles = $utils.getTitle();
          }
          let ErrorMessage = '无错误信息';
          if ($utils.ErrorMessage.length > 0) {
            ErrorMessage = $utils.ErrorMessage.join('\n');
          }
          let Tags = __self.Services.map(o => {
            return o.UserName;
          });
          Tags = Tags.join(',');
          let paramsObj = {
            c_name: __self.UserName,
            c_org: __self.CompanyName,
            c_tags: Tags,
            c_phone: __self.ContactList.ContactPhone,
            c_email: __self.ContactList.ContactEmail,
            c_cf_titles: Titles,
            c_cf_errormessage: ErrorMessage,
            web_token: __self.UserID,
            customer_token: __self.UserID,
          }
          window.lch_udesk.show(paramsObj)
        }
      },
      cancel() {
        let __self = this;
        __self.stateServices = STATE_HIDE;
        __self.ShowFadeFlag = true;
      },
      show() {
        let __self = this;
        __self.state = STATE_SHOW;
        if (__self.CompanyID) {
          // __self.customer = {
          //   "title": "",
          //   "Titles": $utils.getTitle(),
          // }
          if ($utils.ErrorMessage.length > 0) {
            __self.product['错误信息'] = JSON.stringify($utils.ErrorMessage)
          }
          let Titles = '无页面信息';
          if ($utils.getTitle()) {
            Titles = $utils.getTitle();
          }
          let ErrorMessage = '无错误信息';
          if ($utils.ErrorMessage.length > 0) {
            ErrorMessage = $utils.ErrorMessage.join('\n');
          }
          let Tags = __self.Services.map(o => {
            return o.UserName;
          });
          Tags = Tags.join(',');
          if (!window.lch_udesk) {
            __self.udInit(Titles, ErrorMessage, Tags);
          }
          // if (window.lch_udesk&&window.lch_udesk.show) {

          // } else {
          //   __self.udInit(Titles, ErrorMessage, Tags);
          // }

          // window.lch_udesk.show(paramsObj, successCallBack, failureCallBack)
        }
      },
      hide() {
        let __self = this;
        __self.state = STATE_HIDE;
        __self.ShowFadeFlag = false;

      },
      Touchstart(e) {
        let __self = this;
        let CustomerServicesEle = document.getElementById('CustomerServices');
        __self.Flag = 0;
        // e.preventDefault();
        __self.disX = e.touches[0].clientX - CustomerServicesEle.offsetLeft;
        __self.disY = e.touches[0].clientY - CustomerServicesEle.offsetTop;
        __self.starX = e.touches[0].clientX;
        __self.starY = e.touches[0].clientY;
      },
      Touchmove(e) {
        let __self = this;
        if (__self.state == STATE_SHOW) {
          return
        }
        let CustomerServicesEle = document.getElementById('CustomerServices');
        let Ele = document.documentElement;
        let L, T, R, B, starXEnd, starYEnd, moveX, moveY;
        __self.Flag = 1;
        L = e.touches[0].clientX - __self.disX;
        T = e.touches[0].clientY - __self.disY;
        starXEnd = e.touches[0].clientX - __self.starX;
        starYEnd = e.touches[0].clientY - __self.starY;
        if (L < 0) {
          L = 0;
        } else if (L > Ele.clientWidth - CustomerServicesEle.offsetWidth) {
          L = Ele.clientWidth - CustomerServicesEle.offsetWidth;
        }
        if (T < 0) {
          T = 0;
        } else if (T > Ele.clientHeight - CustomerServicesEle.offsetHeight) {
          T = Ele.clientHeight - CustomerServicesEle.offsetHeight;
        }
        moveX = L + "px";
        moveY = T + "px";
        if (T <= 150) {
          __self.isBottom = true;
        } else {
          __self.isBottom = false;
        }
        CustomerServicesEle.style.left = moveX;
        CustomerServicesEle.style.top = moveY;
      },
      Touchend(e) {
        // let __self = this;
        // if (__self.Flag === 0) {
        //   __self.__init();
        // }
      },
      __init() {
        let __self = this;
        if (__self.CompanyID) {
          let model = {
            PageSize: 99999,
            RoleType: __self.RoleTypes.Company,
            RoleID: __self.CompanyID,
            Superior: {
              RoleType: __self.RoleTypes.User,
              RootID: "S00000000120",
            }
          }
          __self.$api.system.getOwners(model).then(o => {
            if (o.data.isSucc) {
              __self.Services = o.data.result;
            }
          })
        } else {
          __self.Services = []
        }

      },
      ShowFade(e) {
        let __self = this;
        if (__self.Flag === 0) {
          __self.ShowFadeFlag = !__self.ShowFadeFlag;
          if (__self.ShowFadeFlag) {
            __self.show();
          } else {
            __self.state = STATE_HIDE;
            $utils.getTitle = function () {
              return undefined;
            }
          }
        }
      },
      ToFeedBack() {
        let __self = this;
        __self.$router.push({
          path: '/system/feedBack'
        })
        __self.ShowFade();
      },
      customerServices() {
        let __self = this;
        if (__self.Flag === 0) {
          __self.__init();
          __self.stateServices = STATE_SHOW;
          __self.ShowFadeFlag = !__self.ShowFadeFlag;
        }
      },
      messageNotify() {
        window.location.href = 'tel://400-088-8020'
        // let __self = this;
        // __self.$router.push({
        //   path: '/system/messageNotify'
        // })
        // __self.ShowFade();
      }
    },
    components: {
      popOut,
      Scroll,
      explain
    }
  }

</script>


// WEBPACK FOOTER //
// customer-services.vue?0795dae8